
export class Project {
  constructor(params){
    this.id= params.id
    this.title= params.name
    this.createdAt= new Date(params.createdAt)
    this.updatedAt= new Date(params.createdAt)
    this.priority= params.priority
    this.uuid = params.uuid;
    this.index=params.index
    this.owner = params.owner
    this.master_id = params.master_id
    this.slaves = params.slaves
    this.description= params.description
    this.isActif= params.actif
    this.company= { name:'Babana Company' }
    this.start_date=params.start_date
    this.assignees= params.assignees
    this.notClient = params.assignees.filter(user => !user.isClient)
    
    this.due_date= params.due_date
    this.tags= params.tags
    this.steps = params.steps
    this.budget= '$2500'
    this.activities= ' blec added a task'
    this.boards= []
    this.action= null
    this.clone = params.clone
    this.auto_start_timer = !!params.auto_start_timer
  }

  addTags(tags){
    this.tags = tags
  }
  updateProperty(property,new_value) {
    this[property] = new_value;
    
    // When assignees are updated, also update notClient
    if (property === 'assignees') {
      this.notClient = new_value.filter(user => !user.isClient);
    }
  }
}